<template>
  <div class="d-flex flex-column align-center">
    <div class="h3 mb-4 mb-md-10">Экстранет</div>

    <v-img
      :src="isInvitationInvalid ? InvalidImage : isAlreadyBelongsToSupplier ? WarningImage : PlaceholderImage"
      width="160"
    />

    <template v-if="isInvitationInvalid">
      <div class="h3 mt-6 text-center">Приглашение недействительно</div>
      <div class="paragraph-s_h mt-6">
        Ваше приглашение устарело, обратитесь к вашему администратору, чтобы получить новое приглашение.
      </div>
      <div class="paragraph-s_h mt-4">
        Если у вас нет намерения присоединяться к существующему пространству, вы можете создать своё Пространство
      </div>

      <e-alert class="mt-6">
        <div>
          <p class="paragraph-m_h mb-1"><b>Внимание!</b></p>
          <p class="paragraph-s_h text-secondary">
            Не создавайте Пространство, если Вы должны получить приглашение. Дублирующиеся Пространства не будут
            одобрены администраторами Экстранета.
          </p>
        </div>
      </e-alert>

      <e-btn
        :to="{
          name: RouteNames.SignIn,
          query: {
            create: 1,
          },
        }"
        variant="primary"
        class="mt-10"
      >
        Создать Пространство
      </e-btn>
      <e-btn variant="link" class="mt-6 mb-4" @click="logout"> Выйти из учетной записи</e-btn>
    </template>

    <template v-else-if="isAlreadyBelongsToSupplier">
      <div class="h3 text-center mt-6">Вы не можете присоединиться к&nbsp;пространству</div>

      <div class="paragraph-s_h mt-6">
        Вы уже привязаны к другому пространству поставщика, чтобы привязать свою учетную запись к другому пространству,
        отмените привязку к своему пространству.
      </div>

      <e-btn to="/" variant="primary" class="mt-10 mb-4"> Перейти в Пространство</e-btn>
    </template>

    <div v-else-if="isLoadingStatus" class="h3 text-link mt-10 mb-5 d-flex align-center">
      <v-progress-circular :size="26" :width="2" indeterminate class="mr-4" />
      Проверка приглашения...
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InvalidImage from '@/assets/img/pages/signin/join/invalid.svg';
import PlaceholderImage from '@/assets/img/pages/signin/join/placeholder_image.svg';
import WarningImage from '@/assets/img/pages/signin/join/warning.svg';
import { EAlert, EBtn } from '@/core/components/ui';
import { useServices } from '@/core/composables/services';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { JoinToSupplierStatus } from '@/graphql/generated';
import { useAuthStore } from '@/parts/auth/store/auth';
import { errorTypes } from '@/parts/errors/utils/error-types';

const $route = useRoute();
const $router = useRouter();
const { $auth } = useServices();
const { joinToSupplier, getProfile } = useAuthStore();

const status = ref<'loading' | 'failed' | 'alreadyBelongsToSupplier'>('loading');

const isLoadingStatus = toRef(() => status.value === 'loading');
const isInvitationInvalid = toRef(() => status.value === 'failed');
const isAlreadyBelongsToSupplier = toRef(() => status.value === 'alreadyBelongsToSupplier');

const logout = () => {
  $auth.logout();
};

const sendJoinCode = async () => {
  const code = $route.params.code;

  if (!code) {
    status.value = 'failed';
    return;
  }

  const response = await joinToSupplier(String(code));

  if (response?.data?.joinToSupplier?.status === JoinToSupplierStatus.Successfull) {
    await getProfile(true);

    await $router.push({ name: RouteNames.Home });
  } else if (response?.errors?.[0].__typename === errorTypes.UserAlreadyBelongsToSupplierError) {
    status.value = 'alreadyBelongsToSupplier';
  } else {
    status.value = 'failed';
  }
};

sendJoinCode();
</script>

<style scoped lang="scss"></style>
